import { createFeatureSelector, createSelector } from "@ngrx/store";

import { DashboardState } from "../../interfaces/dashboard-state.interface";

const selectDashboardState = createFeatureSelector<DashboardState>("dashboard");

export const selectBlockUserFeature = createSelector(
  selectDashboardState,
  (state: DashboardState) => state.blockUserFeature,
);

export const selectUnblockUserFeature = createSelector(
  selectDashboardState,
  (state: DashboardState) => state.unblockUserFeature,
);

export const selectSuccessDeleteUser = createSelector(
  selectDashboardState,
  (state: DashboardState) => state.deleteUserFeature.success,
);

export const selectErrorDeleteUser = createSelector(
  selectDashboardState,
  (state: DashboardState) => state.deleteUserFeature.error,
);
